// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Structure globale */
.page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #F4F7FE;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

/* Header bleu qui s'étire à 100% */
.header-blue {
    background-color: #1B254B;
    padding: 60px 0 140px 0;
    width: 100%;
}

/* Conteneur de contenu : Flexible sur petit PC, limité sur Grand Écran */
.content-container {
    width: 92%;
    max-width: 1600px; /* Limite pour les grands écrans */
    margin: 0 auto;
}

/* Grille principale */
.main-grid {
    display: flex;
    gap: 30px;
    margin-top: -100px; /* Chevauchement sur le bleu */
}

/* Colonnes */
.col-main {
    flex: 2 1; /* Plus large */
    min-width: 0; 
}

.col-side {
    flex: 0.8 1; /* Plus étroite */
    min-width: 320px;
}

/* --- RESPONSIVE --- */

/* Pour les écrans de taille moyenne (Tablettes / Petits Laptops) */
@media (max-width: 1200px) {
    .main-grid {
        flex-direction: column;
    }
    .col-side {
        width: 100%;
    }
    .content-container {
        width: 95%;
    }
}

/* Pour les écrans XXL (Grands moniteurs) */
@media (min-width: 1800px) {
    .content-container {
        max-width: 1750px;
    }
    .workshop-title {
        font-size: 4rem !important;
    }
}

/* Utilitaires */
.card-white {
    background: white;
    border-radius: 30px;
    padding: 30px;
    border: 1px solid #E9EDF7;
    margin-bottom: 30px;
}


/* Style pour la liste des participants dans une session */
.session-card {
    background: #F8F9FE;
    border-radius: 20px;
    padding: 25px;
    margin-bottom: 20px;
    border: 1px solid #E9EDF7;
    transition: all 0.3s ease;
}

.session-card:hover {
    border-color: #4318FF;
    background: #fff;
    box-shadow: 0 10px 20px rgba(0,0,0,0.05);
}

.participant-mini-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px dashed #D1D9E8;
}

.participant-tag {
    background: #fff;
    border: 1px solid #E9EDF7;
    padding: 5px 12px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Animation de clignotement pour la session actuelle */
@keyframes pulse-live {
    0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(5, 205, 153, 0.7); }
    70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(5, 205, 153, 0); }
    100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(5, 205, 153, 0); }
}

.live-indicator {
    width: 12px;
    height: 12px;
    background-color: #05CD99;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    animation: pulse-live 2s infinite;
}

.session-card.is-today {
    border: 2px solid #05CD99; /* Bordure verte pour la session du jour */
    background: #f0fff4; /* Fond très légèrement vert */
}`, "",{"version":3,"sources":["webpack://./src/pages/Ateliers/WorkshopDetails.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;AACf;;AAEA,yEAAyE;AACzE;IACI,UAAU;IACV,iBAAiB,EAAE,kCAAkC;IACrD,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;IACT,kBAAkB,EAAE,8BAA8B;AACtD;;AAEA,aAAa;AACb;IACI,SAAO,EAAE,eAAe;IACxB,YAAY;AAChB;;AAEA;IACI,WAAS,EAAE,iBAAiB;IAC5B,gBAAgB;AACpB;;AAEA,uBAAuB;;AAEvB,mEAAmE;AACnE;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;;AAEA,2CAA2C;AAC3C;IACI;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA,0DAA0D;AAC1D;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,uDAAuD;AACvD;IACI,KAAK,sBAAsB,EAAE,0CAA0C,EAAE;IACzE,MAAM,mBAAmB,EAAE,2CAA2C,EAAE;IACxE,OAAO,sBAAsB,EAAE,wCAAwC,EAAE;AAC7E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB,EAAE,0CAA0C;IACrE,mBAAmB,EAAE,8BAA8B;AACvD","sourcesContent":["/* Structure globale */\n.page-wrapper {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #F4F7FE;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n/* Header bleu qui s'étire à 100% */\n.header-blue {\n    background-color: #1B254B;\n    padding: 60px 0 140px 0;\n    width: 100%;\n}\n\n/* Conteneur de contenu : Flexible sur petit PC, limité sur Grand Écran */\n.content-container {\n    width: 92%;\n    max-width: 1600px; /* Limite pour les grands écrans */\n    margin: 0 auto;\n}\n\n/* Grille principale */\n.main-grid {\n    display: flex;\n    gap: 30px;\n    margin-top: -100px; /* Chevauchement sur le bleu */\n}\n\n/* Colonnes */\n.col-main {\n    flex: 2; /* Plus large */\n    min-width: 0; \n}\n\n.col-side {\n    flex: 0.8; /* Plus étroite */\n    min-width: 320px;\n}\n\n/* --- RESPONSIVE --- */\n\n/* Pour les écrans de taille moyenne (Tablettes / Petits Laptops) */\n@media (max-width: 1200px) {\n    .main-grid {\n        flex-direction: column;\n    }\n    .col-side {\n        width: 100%;\n    }\n    .content-container {\n        width: 95%;\n    }\n}\n\n/* Pour les écrans XXL (Grands moniteurs) */\n@media (min-width: 1800px) {\n    .content-container {\n        max-width: 1750px;\n    }\n    .workshop-title {\n        font-size: 4rem !important;\n    }\n}\n\n/* Utilitaires */\n.card-white {\n    background: white;\n    border-radius: 30px;\n    padding: 30px;\n    border: 1px solid #E9EDF7;\n    margin-bottom: 30px;\n}\n\n\n/* Style pour la liste des participants dans une session */\n.session-card {\n    background: #F8F9FE;\n    border-radius: 20px;\n    padding: 25px;\n    margin-bottom: 20px;\n    border: 1px solid #E9EDF7;\n    transition: all 0.3s ease;\n}\n\n.session-card:hover {\n    border-color: #4318FF;\n    background: #fff;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.05);\n}\n\n.participant-mini-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px dashed #D1D9E8;\n}\n\n.participant-tag {\n    background: #fff;\n    border: 1px solid #E9EDF7;\n    padding: 5px 12px;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Animation de clignotement pour la session actuelle */\n@keyframes pulse-live {\n    0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(5, 205, 153, 0.7); }\n    70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(5, 205, 153, 0); }\n    100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(5, 205, 153, 0); }\n}\n\n.live-indicator {\n    width: 12px;\n    height: 12px;\n    background-color: #05CD99;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 8px;\n    animation: pulse-live 2s infinite;\n}\n\n.session-card.is-today {\n    border: 2px solid #05CD99; /* Bordure verte pour la session du jour */\n    background: #f0fff4; /* Fond très légèrement vert */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
